module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "welcome"
    }
  }, [_c('h1', {}, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {}, [_vm._v(_vm._s(_vm.desc))]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")]), _vm._v(" | \n\t\t\t"), _c('router-link', {
    attrs: {
      "to": "/note"
    }
  }, [_vm._v("Note")]), _vm._v(" | \n\t\t\t"), _c('router-link', {
    attrs: {
      "to": "/tool"
    }
  }, [_vm._v("Weather")]), _vm._v(" | \n\t\t\t"), _c('router-link', {
    attrs: {
      "to": "/stock"
    }
  }, [_vm._v("Stock")]), _vm._v(" |\n\t\t\t"), _c('router-link', {
    attrs: {
      "to": "/info"
    }
  }, [_vm._v("Discovery")])], 1), _vm._v(" "), _vm._m(0, false, false)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "page__ft"
  }, [_c('a', {
    attrs: {
      "href": "//hijiangtao.github.io/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("@hijiangtao")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a2578a0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 558
// module chunks = 1